'use client';

import Script from 'next/script';
import { GDPR } from '@/components/GDPR';
import { useSiteContext } from '@/context/SiteContext';

export const AdmiralBootstrap = () => {
	const { config: siteConfig } = useSiteContext();
	const isEnabled = siteConfig?.analytics?.providers?.Admiral?.isEnabled;

	if (!isEnabled) return null;

	return (
		<GDPR
			purposes={[
				'storage',
				'personalization',
				'advertising',
				'measurement/development',
			]}
			vendorId="admiral"
		>
			<Script src="/.api/admiral" />
		</GDPR>
	);
};
